<template>
	<div>
		<List :mare_id="horse.horse_id" :mare_nom="horse.horse_nom" />
	</div>
	<!-- <div>
		<div class="container-fluid" v-if="table">
			<div class="row">
				<div class="col-12">
					<div class="box">
						<CustomTable
							id_table="contract_mare_client_area"
							sortBy="contract_num"
							:busy.sync="table_busy"
							:items="contracts"
							primaryKey="contract_num"
							:hide_if_empty="true"
							:rawColumns="rawColumnNames"
							ref="contractTable"
							:hasExportOption="false"
							:showPagination="false"
						/>
					</div>
				</div>
			</div>
		</div>
		<div v-else>
			<ContractShutter :contract_id="contract_id" :mare_id="horse.horse_id" ></ContractShutter>
		</div>

		<TiersModal ref="tiers_modal" @submit="tiersInfosChecked" />
	</div> -->
</template>

<script type="text/javascript">
	export default {
		name: "ContractMare",
		props: ['horse'],
		components: {
			List : () => import('@/components/Contract/ListV2')
		},
	}
</script>
